export default __webpack_public_path__ + "static/media/h.2f43d924.pdf";